import React from 'react';
import PropTypes from 'prop-types';

export const ModalDisabledOverlay = ({ children }) => (
  <div className='modal__disabledOverlay u-full-width u-full-height'>
    <div className='modal__disabledOverlay_front u-full-width u-full-height z1'>{children}</div>
    <div className='modal__disabledOverlay_back u-full-width u-full-height bg-white z0' />
  </div>
);

ModalDisabledOverlay.propTypes = {
  children: PropTypes.any
};

ModalDisabledOverlay.defaultProps = {
  children: null
};

export default ModalDisabledOverlay;
